import React from 'react'

import { DEFAULT_ASSET_LOGO_SRC, DEFAULT_COMPANY_LOGO_SRC } from '@modules/profile/constants'
import { AnyProfile, Company, CompanyAsset, Delegate, ProfileType } from '@modules/search/types'

import { StyledAltLogoWrapper, StyledLogo, StyledLogoWrapper } from './index.styles'

type ProfileLogoDataProps = Partial<AnyProfile>
const ProfileLogo = ({
  profileData,
  profileType,
  width,
  height,
  defaultLogoSize,
  circleView,
  showAltText = true,
  backgroundColor,
  ...rest
}: {
  profileData: ProfileLogoDataProps
  profileType: AnyProfile['@type']
  width?: number
  height?: number
  defaultLogoSize?: number
  showAltText?: boolean
  circleView?: boolean
  backgroundColor?: string
}) => {
  if (!profileData) return null

  let src
  let altText = ''
  let isDefaultIcon = true

  switch (profileType) {
    case ProfileType.company: {
      const { logo, name, profileData: companyProfileData } = profileData as Company
      src = logo || companyProfileData?.logo || DEFAULT_COMPANY_LOGO_SRC
      altText = name
      isDefaultIcon = !logo
      break
    }
    case ProfileType.delegate: {
      const { profilePicture, firstName, lastName } = profileData as Delegate
      src = profilePicture
      isDefaultIcon = !profilePicture

      altText = `${firstName ? firstName.charAt(0).toUpperCase() : ''}${lastName ? lastName.charAt(0).toUpperCase() : ''}`
      break
    }
    default: {
      const { title } = profileData as CompanyAsset
      src = DEFAULT_ASSET_LOGO_SRC
      altText = title
    }
  }

  const currentWidth = isDefaultIcon && defaultLogoSize ? defaultLogoSize : width

  if (!showAltText && !src) return null

  return (
    <StyledLogoWrapper
      id="search_card-profile_name"
      $logoWidth={currentWidth}
      $logoHeight={height || currentWidth}
      $circleView={circleView && !isDefaultIcon}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...rest}
      data-testid="profile-logo-wrapper"
    >
      {src && <StyledLogo alt={altText} src={src} data-testid={isDefaultIcon ? 'profile-default-logo' : 'profile-logo'} />}
      {showAltText && !src && (
        <StyledAltLogoWrapper $circleView={circleView} $background={backgroundColor} data-testid="alt-logo-wrapper">
          {altText}
        </StyledAltLogoWrapper>
      )}
    </StyledLogoWrapper>
  )
}

export default ProfileLogo
